import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { EventCard } from "@/components/site/EventCard";
import { PhotographerCard } from "@/components/site/PhotographerCard";
import { Eyebrow, Reveal } from "@/components/site/Motion";

export const RecentEvents = () => {
  const { data } = useFetch("/events?limit=6", []);
  const events = Array.isArray(data) ? data : [];
  if (!events.length) return null;
  return (
    <section className="border-t border-white/10 bg-ink-2/40 py-24 lg:py-32" data-testid="recent-events-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow>Galerias recentes</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-6xl">Você estava em algum?</h2>
          </div>
          <Link to="/eventos" className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-3 text-sm font-semibold hover:border-flash" data-testid="recent-events-all-btn">
            Todas as galerias <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
          </Link>
        </Reveal>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {events.slice(0, events.length >= 6 ? 6 : 3).map((ev, i) => (
            <Reveal key={ev.id} delay={(i % 3) * 0.08}><EventCard ev={ev} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export const PhotographersSection = () => {
  const { data } = useFetch("/photographers", []);
  const list = Array.isArray(data) ? data : [];
  if (!list.length) return null;
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32" data-testid="photographers-section">
      <Reveal className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow>Fotógrafos associados</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-6xl">Escolha quem vai te ver lá.</h2>
        </div>
        <p className="text-haze md:text-lg lg:col-span-5">Peça um orçamento ou reserve a data direto no perfil de cada fotógrafo da rede Eutevila.</p>
      </Reveal>
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.slice(0, 6).map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08}><PhotographerCard p={p} index={i} /></Reveal>
        ))}
      </div>
    </section>
  );
};
